export { getSupportedLanguages, translateText, translateTextBatch } from './TranslationService';
